import { type Icon as IconType } from '@tabler/icons-react-native'
import { clsx } from 'clsx'
import { ComponentRef, forwardRef } from 'react'

import {
  Button,
  ButtonIcon,
  ButtonText,
  type ButtonIconProps,
  type ButtonProps,
  type ButtonTextProps
} from '@/components'
import { COLOR_BLACK, COLOR_WHITE } from '@/lib'

export interface ProfileButtonProps extends Omit<ButtonProps, 'children'> {
  Icon?: IconType
  iconProps?: ButtonIconProps
  label: string
  labelClassName?: ButtonTextProps['className']
  withBlackText?: boolean
}

export const ProfileButton = forwardRef<ComponentRef<typeof Button>, ProfileButtonProps>(
  ({ className, Icon, iconProps, label, labelClassName, withBlackText, ...props }, ref) => (
    <Button
      className={clsx(
        'gap-3 rounded-full bg-transparent px-3 data-[hover=true]:bg-transparent data-[active=true]:bg-transparent',
        className
      )}
      ref={ref}
      {...props}
    >
      {Icon ? (
        <ButtonIcon
          as={Icon}
          color={withBlackText ? COLOR_BLACK : COLOR_WHITE}
          strokeWidth={3}
          {...iconProps}
        />
      ) : null}
      <ButtonText
        className={clsx(
          'font-poppinsSemiBold',
          withBlackText
            ? 'text-black data-[hover=true]:text-black data-[active=true]:text-black'
            : 'text-white data-[hover=true]:text-white data-[active=true]:text-white',
          labelClassName
        )}
        numberOfLines={1}
      >
        {label}
      </ButtonText>
    </Button>
  )
)

ProfileButton.displayName = 'ProfileButton'
